import { React, useRef, forwardRef, useImperativeHandle, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import FetchModule from '../../Share/Network/FetchModule';
import { useLanguage } from '../../../Context/LanguageContext';

import CoachSettingInfoBox from './CoachSettingInfoBox';
import DeleteConfirmModal from './Modal/DeleteConfirmModal';
import NewCoachAddModal from './Modal/NewCoachAddModal';

const CoachSettingView = forwardRef((props, ref) => {
  const history = useHistory();

  const [isClicked, setIsClicked] = useState(false);
  const [isClickedDelete, setIsClickedDelete] = useState(false);
  const [data, setData] = useState([]);
  const [clickIndex, setClickIndex] = useState(-1);
  const [deleteData, setDeletedDate] = useState(undefined);
  const [rendering, setRendering] = useState(false);

  const { t } = useLanguage();
  const TopLevelRef = useRef();

	useImperativeHandle(ref, () => ({
		setOpacity: (val) => {
			TopLevelRef.current.style.opacity = val;
		},
    setZindex: (val) => {
      TopLevelRef.current.style.zIndex = val;
    },
    setIsClicked: (val) => {
      setIsClicked(val);
    }
	}))

  // 렌더링시 데이터 호출하는 API //
  useEffect(() => {
    const fetchModule = new FetchModule();
		(
			async () => {
				const responseData = await fetchModule.getData('coach/', 'GET');

        // console.log("coach: \n", responseData);

				if (responseData.status === 200) {
          const sortedData = [...responseData.data].sort((a, b) => {
            if (a.linkCoachId === 'COACH') return -1;
            if (b.linkCoachId === 'COACH') return 1;
            return 0;
          });

          setData(sortedData);
        }
				else if (responseData.status === 401) {
          alert(t('settingCoach.loginRequired'));
          history.push('/');
        }
			}
		)();
  }, [history, rendering])

  // Modal이 꺼지면 전달 Index를 재 정리 //
  useEffect(() => {
    if (!isClicked) setClickIndex(-1);
  }, [isClicked])

  function modifyClick(index) {
    if (data[index]?.linkCoachId === 'COACH') return;
    setClickIndex(index);
    setIsClicked(true);
  }

  function deleteClick(index) {
    setDeletedDate(data[index]);
    setIsClickedDelete(true);
  }

  // 삭제 확인 버튼 클릭시 //
  function onClickDeleteYes() {
    let requestData = {
      teacherId: deleteData.id
    }

    const fetchModule = new FetchModule();
		(
			async () => {
				const responseData = await fetchModule.postDataVersion2('teacher/delete/', 'POST', requestData);
        
				if (responseData.status === 200) setRendering(!rendering);
				else if (responseData.status === 401) {
          alert(t('settingCoach.loginRequired'));
          history.push('/');
        }
        else {
          alert(responseData.error);
        }

        setIsClickedDelete(false);
        setDeletedDate(undefined);
			}
		)();
  }

  return (
    <TopLevelWrapper ref={TopLevelRef}>
      { isClicked && <NewCoachAddModal data={data} index={clickIndex} exitClickFn={() => setIsClicked(false)} rendering={() => setRendering(!rendering)} /> }
      { isClickedDelete && <DeleteConfirmModal title={t('settingCoach.deleteTitle')} itemName={deleteData === undefined ? 'None' : (deleteData.name + t('settingCoach.coachSuffix'))} clickNoFn={() => setIsClickedDelete(false)} clickYesFn={onClickDeleteYes}/> }
      {
        data.map((data, index) => (
          <CoachSettingInfoBox key={index} data={data} index={index} modifyClickFn={modifyClick} deleteClickFn={deleteClick}/>
        ))
      }
    </TopLevelWrapper>
  )
})

export default CoachSettingView;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;

  box-sizing: border-box;
  width: 1035px;
  min-height: 500px;

  gap: 20px;

  margin-top: 30px;
  margin-bottom: 96px;

  transition: all 0.3s ease-in-out;
`;
